import { useState } from 'react'
import { Gamepad2 } from 'lucide-react'
import { cn } from '../../lib/cn'

interface GameArtProps {
  appid: number
  src: string | null | undefined
  name: string | null | undefined
  className?: string
}

/**
 * Renders ONLY catalog art the API returns, keyed by appid. If the image is
 * missing or fails to load, shows a neutral placeholder tied to the real appid
 * — never synthesizes a cover (skill guardrail #3, grounding).
 */
export function GameArt({ appid, src, name, className }: GameArtProps) {
  const [failed, setFailed] = useState(false)

  if (!src || failed) {
    return (
      <div
        data-appid={appid}
        className={cn(
          'flex items-center justify-center rounded-card bg-surface-sunken text-text-faint ring-1 ring-border',
          className,
        )}
        aria-hidden="true"
      >
        <Gamepad2 className="h-6 w-6" strokeWidth={1.5} />
      </div>
    )
  }

  return (
    <img
      src={src}
      alt={name ? `${name} cover art` : ''}
      data-appid={appid}
      // Long feeds render dozens of covers — defer offscreen decode work.
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
      className={cn('rounded-card object-cover ring-1 ring-border', className)}
    />
  )
}
